export default __webpack_public_path__ + "static/lower1_2-0571e13cdee9e203fd3f1b447617ac90.jpg";